module.exports = __webpack_public_path__ + "static/maps-baf234fb5603317c861a6a9ae81e8335.png";